import React from 'react';
import styled from 'styled-components';
import { history } from 'helpers/History';
import { ButtonPrimary } from 'components/Core/Button/Button';

const Overlay = styled.div`
  position: fixed;
  z-index: 2000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(74, 74, 74, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 4.5px;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12),
    0 3px 5px -1px rgba(0, 0, 0, 0.2);
  padding: 30px 25px;
  max-width: 360px;
  width: 90%;
  text-align: center;
`;

const Icon = styled.div`
  font-size: 36px;
  color: #01366b;
  margin-bottom: 15px;
`;

const Message = styled.p`
  color: #01366b;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  margin: 0 0 25px 0;
`;

const StyledButton = styled(ButtonPrimary)`
  padding: 12px 24px;
  font-size: 13px;
`;

const ScreenReaderOnly = styled.h2`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;

class ModalOrderDisabled extends React.Component {
  constructor(props) {
    super(props);
    this.buttonRef = React.createRef();
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    if (this.buttonRef.current) {
      this.buttonRef.current.focus();
    }
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown(e) {
    if (e.key === 'Tab') {
      e.preventDefault();
      if (this.buttonRef.current) {
        this.buttonRef.current.focus();
      }
    }
  }

  render() {
    return (
      <Overlay>
        <ModalContent
          role="dialog"
          aria-modal="true"
          aria-labelledby="order-disabled-title"
          aria-describedby="order-disabled-message"
        >
          <Icon className="icon-delivery" aria-hidden="true" />
          <ScreenReaderOnly id="order-disabled-title">
            Passage de commande désactivé
          </ScreenReaderOnly>
          <Message id="order-disabled-message">
            Le passage de commande est temporairement désactivé en raison d'une maintenance. Il sera
            rétabli dans les 24h
          </Message>
          <StyledButton
            innerRef={this.buttonRef}
            onClick={() => history.push('/landing')}
            tabIndex="0"
          >
            RETOUR A L&apos;ACCUEIL
          </StyledButton>
        </ModalContent>
      </Overlay>
    );
  }
}

export default ModalOrderDisabled;
